export const WinColors: Record<string, string> = {
  // <string, CSSColor> if you can find it
  "Natural Royal Flush": "#FFFFFF",
  "Four Deuces": "#FF0000",
  "Wild royal Flush": "#0077ff",
  "Five of a Kind": "#ff00ff",
  "Straight Flush": "#FF0000",
  "Four of a Kind": "#7700ff",
  "Full House": "#0000ff",
  Flush: "#77ff00",
  Straight: "#FFFF00",
  "Three of a Kind": "#00ff00",
  Junk: "#FF0000",
};
